import { getStillRunTable } from './stillRunTable';
import { STILL_RUN_TITLES } from './stillRunTitles';

export const getStillRunFields = props => [STILL_RUN_TITLES, ...getStillRunTable(props)];
